import { Injectable } from '@angular/core';
import { AuthService } from './services/auth.service';
import { Router, ActivatedRouteSnapshot, CanActivate } from '@angular/router';

// if (role == 'ROLE_TENANT_ADMIN' && (
//   (itemName == "administration") || ((itemName == "fleetStatus"))
//   || itemName == "dashboard" || itemName == "emergency-bol" 
//   || itemName == "dispatchLite" || itemName == "details-dashboard"
// )) {
//   return true;
// }

// if ((role == 'ROLE_FTP_IMPORT' || role == 'ROLE_WHO_OWNS_IT') && (itemName == "administration" || itemName == "dashboard" || itemName == "details-dashboard")) {
//   return true;
// }

// if(role == 'ROLE_WHO_OWNS_IT' && itemName == "take-order"){
//   let allowOrderFromPortal = localStorage.getItem("allowOrderFromPortal") == "true";
//   if(allowOrderFromPortal){
//     return true;
//   }
// }
// // && 
// // if((role == 'ROLE_STATION_INVENTORY' && itemName == "stationInventory")){
// // if(this.user.user.email == "dispatch@prestigewash.com" && itemName == "stationInventory"){
// //   return true;
// // }
// let found = false;
// if(this.modules && this.modules.length > 0){
//   this.modules.forEach(module => {
//     if(module.userModuleName == "Inventory Controls"){
//       found = true;
//     }
//   })
// }
// if(itemName == "stationInventory" && found){
//   return true;
// }

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(public auth: AuthService, public router: Router) {}
  canActivate(): boolean {
    let isAllowed: boolean = false;
    if (!this.auth.isUserLoggedIn()) {
      isAllowed = false;
    } else {
      let user: any = localStorage.getItem("user");
      user = user ? JSON.parse(user) : null;
      let url = this.router.getCurrentNavigation().finalUrl.toString();
      if(user){
        let role = user?.user?.role?.role;
        switch(role){
          case "ROLE_SUPER_ADMIN":
            isAllowed = true;
            break;
          case "ROLE_TENANT_ADMIN":
            isAllowed = url?.includes("administration") || url?.includes("fleetStatus")
            || url?.includes("dashboard") || url?.includes("emergency-bol") 
            || url?.includes("dispatchLite") || url?.includes("details-dashboard") 
            || url?.includes("fleet-status") || url?.includes("device/tenant-device")
            break;
          case "ROLE_DRIVER_ADMIN":
            isAllowed = url?.includes("dashboard") && !url?.includes("dashboard/");
            break;
          case "ROLE_DRIVER":
            isAllowed = false;
            break;
          case "ROLE_WHO_OWNS_IT":
            isAllowed = (url?.includes("dashboard") || url?.includes("details-dashboard") 
            || url?.includes("take-order") || url?.includes("tank-inventory")) 
            && !url?.includes("user-mngnt") && !url?.includes("graph");
            break;
          case "ROLE_WHO_RECEIVES_IT":
            isAllowed = url?.includes("dashboard") && !url?.includes("dashboard/");
            break;
          case "ROLE_STATION_INVENTORY":
            isAllowed = url?.includes("dashboard") && !url?.includes("dashboard/");
            break;
          case "ROLE_FLEET_MAINTENANCE":
            isAllowed = url?.includes("dashboard") && !url?.includes("dashboard/");
            break;
          case "ROLE_FTP_IMPORT":
            isAllowed = (url?.includes("dashboard") || url?.includes("details-dashboard")) 
            && !url?.includes("user-mngnt") && !url?.includes("graph") && !url?.includes("station-inventory");
            break;
          case "ROLE_CSV_CONNECT":
            break;
          default:
            break;
        }
      }
      
    }
    if(!isAllowed){
      this.router.navigate(['login'])
    }
    return isAllowed;
  }
}
